module.exports = __webpack_public_path__ + "static/media/404.96cc598d.png";